export const PERMISSION_BLOCKED_MESSAGE =
  "Notifications are blocked for this site. Allow them in your browser's site settings and try again."

export const PERMISSION_REQUIRED_MESSAGE = 'Notification permission is required to enable push notifications.'

export const SIGNATURE_REJECTED_MESSAGE = 'Signature request was rejected. Push notifications were not enabled.'

// Prefixes for registration failures; the reason is appended by the registration flow
export const ENABLE_FAILED_MESSAGE = 'Failed to enable push notifications.'

export const DISABLE_FAILED_MESSAGE = 'Failed to disable push notifications.'

export const RETRY_MESSAGE = 'Please try again.'

export const RENEWAL_NOTIFICATION_KEY = 'renewal'
export const RENEWAL_MESSAGE =
  'We’ve upgraded your notification experience! To continue receiving important updates seamlessly, you’ll need to sign this message on every chain you use.'
